import { render, staticRenderFns } from "./GlossaryIcon.vue?vue&type=template&id=0f6efbbd&scoped=true&"
import script from "./GlossaryIcon.vue?vue&type=script&lang=js&"
export * from "./GlossaryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6efbbd",
  null
  
)

export default component.exports